import { forkJoin as observableForkJoin } from "rxjs";

import type { IScope } from "angular";
import { cloneDeep, isEmpty } from "lodash";
import { finalize } from "rxjs/operators";

import type { IProfileService } from "App/Modules/Auth";

import type { IFormContainerResolve, IPageService } from "App/Modules/Services";
import { PatchDelta } from "App/Modules/Services";

import "angular-translate";

import type { ILanguage, IProfile, IResponseWithLoading, IrMap } from "App/Modules/Models";
import type { ILocalesRepository, ITimeZonesRepository } from "App/Modules/Repositories";
import { extendWithLoadingAndFail } from "../../../../../Services/ObservableExtensions";

export default class LocalizationEditComponentController {
    public static $inject = [
        "$scope",
        "$translate",
        "irPageService",
        "mmTimeZonesRepository",
        "irLocalesRepository",
        "mmProfileService",
    ];

    public resolve: IFormContainerResolve<IProfile, void>;

    public original: IProfile;

    public edited: IProfile;

    public editResponse: IResponseWithLoading<IProfile>;

    public isDataLoading = true;

    public responseError: IResponseWithLoading<any>;

    public languages: IResponseWithLoading<ILanguage[]>;

    public locales: IResponseWithLoading<string[]>;

    public timeZones: IResponseWithLoading<IrMap<string, string>>;

    constructor(
        private readonly $scope: IScope,
        private readonly $translate: angular.translate.ITranslateService,
        private readonly pageService: IPageService,
        private readonly timeZonesRepository: ITimeZonesRepository,
        private readonly localesRepository: ILocalesRepository,
        private readonly profileService: IProfileService,
    ) {}

    public $onInit() {
        this.original = this.resolve.formData;
        this.edited = cloneDeep(this.original);

        const languagesObservable = extendWithLoadingAndFail(this.profileService.getLanguages());
        const localesObservable = extendWithLoadingAndFail(this.localesRepository.getAllLocales());
        const timeZonesObservable = extendWithLoadingAndFail(this.timeZonesRepository.getAllTimeZones());

        observableForkJoin([languagesObservable, localesObservable, timeZonesObservable])
            .pipe(
                finalize(() => {
                    this.isDataLoading = false;
                    this.$scope.$applyAsync();
                }),
            )
            .subscribe(
                (result: Array<IResponseWithLoading<any>>) => {
                    [this.languages, this.locales, this.timeZones] = result;
                    if (!this.languages.isLoading && this.languages.data) {
                        // eslint-disable-next-line no-restricted-syntax
                        for (const language of this.languages.data) {
                            language.translated = this.$translate.instant(`Entities.Language.${language.key}`);
                        }
                    }
                },
                (error) => {
                    this.responseError = error;
                },
            );
    }

    public changeLanguage(): void {
        // console.log("Clicked ", language);
        // const localeKey = (language.languageKey.substr(0, 2)
        //     + language.languageKey.substr(3, 2).toUpperCase());
        // console.log("Key ", localeKey);
        // this.profile.userInformation.locale = Locale[localeKey as keyof typeof Locale];
        // console.log("Set locale to ", this.profile.userInformation.locale);
        // let localeString = Locale[this.profile.userInformation.locale];
        // localeString = localeString.substr(0, 2) + "-" + localeString.substr(2, 2);
        // (this.profile.userInformation as any).language = localeString;
        // this.languages.isLoading = true;
        // this.$translate.use(localeString)
        //     .finally(() => this.languages.isLoading = false);
    }

    public cancel() {
        this.resolve.options.onCancel();
    }

    public save() {
        const delta = PatchDelta.difference(this.original, this.edited);
        if (!isEmpty(delta)) {
            extendWithLoadingAndFail(this.profileService.patch(delta))
                .pipe(finalize(() => this.$scope.$applyAsync()))
                .subscribe(
                    (response) => {
                        this.editResponse = response;
                        if (!response.isLoading && response.data) {
                            this.resolve.options.onOk(response.data);
                        }
                    },
                    (error) => {
                        this.editResponse = error;
                    },
                );
        } else {
            this.cancel();
        }
    }
}
